/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<b>' + (comparing?'<span class="ais-hit--price-discounted">':'') + formatPrice(price) + (comparing?'</span>':'') + '</b>';
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = this._highlightResult.title.value;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = algolia.helpers.fullEscapedAttribute(
        this._highlightResult.title.value
      );
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.product_type.value
      );
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.vendor.value
      );
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    handleize: function handleize (text, render) {
      return render(text).toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
    },
    sizeBar: function sizeBar (text, render) {
      var res = '';
  
        var sizes = this.named_tags.sizes || '';
        if (typeof sizes == 'string') sizes = [sizes];
        var kids_subtype = this.named_tags['kids-subtype'] || '';
        // WARNING: Any changes in the below logic must also be duplicated in snippets/product-item.liquid
        res += '<div class="ProductItem__SizeList">';
        if (window.searchResults[this.id].variants.length <= 1) {
          res += '<span class="size-one-size">ONE SIZE</span>';
        } else {
          for(var i = 0; i<window.searchResults[this.id].variants.length; i++) {
            var variant_title = window.searchResults[this.id].variants[i].title;
            switch (variant_title) {
              case "Extra Small":
                variant_title = "XS";
                break;
              case "Small":
                variant_title = "S";
                break;
              case "Medium":
                variant_title = "M";
                break;
              case "Large":
                variant_title = "L";
                break;                
              case "Extra Large":
                variant_title = "XL";
                break;
            }

            var lowercase_title = variant_title.toLowerCase();
            var available = window.searchResults[this.id].variants[i].available;

            res += '<span class="size-' + lowercase_title + ' ' + (available ? '' : 'disabled') + '">'+variant_title+'</span>';
          }  
        }
        res += '</div>'
      
      return res;
    },
    badges: function badges (text, render) {
      var shopify_asset_url_prefix = 'https://migolondrina.com/cdn/shop/t/47/assets/';
      var res = '';
      let oak_collection_logo = '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-logomark" viewBox="0 0 31.9 28.6" color="#f6967b"><g transform="translate(0 -1)translate(44 0.202)"><path class="st0" d="M-44 0.8h31.9v28.6H-44V0.8z" fill="none"/><defs><rect x="-44" y="0.8" width="31.9" height="28.6"/></defs><g class="st1"><path class="st2" d="M-36.4 29.4c-0.2 0-0.3-0.1-0.4-0.2 -0.1-0.1-0.1-0.2 0-0.4 0.1-0.1 0.2-0.2 0.3-0.3 0.3-0.1 0.6-0.2 0.8-0.3 0.3-0.1 0.7-0.2 1-0.4 0.3-0.1 0.5-0.2 0.8-0.3 0.1-0.1 0.2-0.1 0.3-0.2 0.2-0.1 0.4-0.2 0.7-0.3 0.1 0 0.1-0.1 0.1-0.1l0.2-0.1 0 0c0.3-0.2 0.5-0.3 0.8-0.5 0.1-0.1 0.2-0.2 0.3-0.2 0.1-0.1 0.1-0.1 0.2-0.2 0.1-0.1 0.1-0.1 0.2-0.2 0.2-0.1 0.3-0.3 0.5-0.4 0.2-0.1 0.3-0.2 0.5-0.3 0.2-0.1 0.3-0.1 0.5-0.2 0.1-0.1 0.3-0.2 0.3-0.4 0.1-0.3 0.3-0.7 0.6-0.9 0.1-0.1 0.2-0.2 0.2-0.3 0.1-0.2 0.2-0.4 0.3-0.6 0.1-0.4 0.4-0.7 0.8-0.9 0.3-0.1 0.6-0.2 0.9-0.4 0.1-0.1 0.2-0.1 0.3-0.2 0.1 0 0.2-0.1 0.3-0.1 0.2-0.1 0.3-0.2 0.2-0.4 0-0.1-0.1-0.2-0.2-0.2s-0.2 0-0.2 0.1c-0.2 0.1-0.5 0.1-0.7 0.2l0 0c-0.1 0-0.2-0.1-0.3-0.1 -0.7-0.9-1.7-1.5-2.9-1.8 -1.6-0.5-3.4-1.1-5.1-1.6 -1.8-0.6-3.6-1.4-5.2-2.4 -0.3-0.3-0.8-0.5-1.2-0.8 -0.5-0.3-0.9-0.5-1.4-0.8 -0.2-0.2-0.5-0.4-0.7-0.6 -0.1-0.1-0.2-0.2-0.3-0.3 -0.1 0-0.1-0.1-0.1-0.2 0-0.1 0-0.3-0.1-0.4 0-0.1 0-0.1 0-0.2 0.1 0 0.1 0 0.2 0 0.1 0 0.2 0 0.3 0L-43 12l0 0c0.9 0.4 1.8 0.9 2.6 1.3 1.7 0.9 3.6 1.5 5.5 1.8 0.2 0 0.4 0.1 0.7 0.1 0.4 0.1 0.9 0.2 1.3 0.3 0.1 0 0.3 0 0.4 0 0.3 0 0.6 0 0.9-0.1 0.2 0 0.3-0.1 0.3-0.2s0-0.2-0.1-0.4c-0.2-0.3-0.5-0.7-0.7-1l0 0c-0.5-0.8-1.1-1.6-1.6-2.4 -0.2-0.2-0.3-0.5-0.5-0.7 -1.1-1.3-1.9-2.7-2.7-4.2 -0.4-0.9-0.7-1.7-1.1-2.6l-0.3-0.7c0-0.1-0.1-0.3-0.1-0.4 0-0.1 0-0.1-0.1-0.2l0.1-0.1 0 0c0.1 0 0.1 0.1 0.2 0.1 0.1 0.1 0.3 0.2 0.4 0.3l0.1 0.1c0.5 0.6 1 1.2 1.4 1.9 0.3 0.5 0.6 0.9 0.9 1.4 0.5 0.9 1.1 1.8 1.8 2.6 1.5 1.9 3.2 3.7 5 5.4 0.6 0.5 1.3 0.9 2.1 1.1 1.1 0.3 2.3 0.5 3.4 0.7 0.4 0.1 0.7 0.1 1.1 0.2l0 0c0 0 0 0 0.1 0h0.1l-0.1-0.1c-0.2-0.1-0.2-0.2-0.3-0.2 -0.1-0.1-0.1-0.2-0.1-0.3 0-0.6 0.2-1.2 0.6-1.7 0.3-0.5 0.4-1 0.4-1.5 0-0.2 0-0.5 0-0.7 0-0.4 0-0.9 0-1.3 0-0.1 0-0.3 0.1-0.4 0.2-0.8 0.2-1.7-0.2-2.5 -0.1-0.3-0.1-0.5-0.1-0.8 0-0.1 0-0.2 0-0.2 0-0.4-0.1-0.9-0.4-1.2L-22 5.3c-0.4-0.8-0.8-1.6-1.4-2.4C-23.6 2.6-23.8 2.3-24 2c-0.1-0.4-0.1-0.4-0.2-0.5 -0.1-0.2 0-0.4 0.2-0.5 0 0 0 0 0.1 0 0 0 0.1 0 0.1-0.1l0 0h0.1c0.3 0.1 0.5 0.4 0.7 0.7 0.1 0.1 0.2 0.3 0.3 0.4 0.3 0.3 0.5 0.6 0.8 0.9s0.6 0.6 0.9 1l0.2 0.1c1.1 1.2 2.1 2.5 3.1 3.8 0.6 0.9 1 1.8 1.3 2.9l0 0c0 0.1 0.1 0.3 0.1 0.4 0.6 1.9 0.4 3.9-0.6 5.6 0 0 0 0.1-0.1 0.1v0.1l0.3 0.1c0.2 0.1 0.5 0.1 0.7 0.2 0.6 0.2 1.2 0.6 1.7 1.2s1 1 1.7 1.3c0 0 0.1 0 0.1 0.1 0.2 0.1 0.3 0.3 0.3 0.4s-0.1 0.2-0.3 0.3c-0.4 0.2-0.7 0.5-1.1 0.8 -0.1 0.1-0.2 0.2-0.3 0.2 -1.5 1.1-3.3 1.8-5.1 1.9h-0.1c-0.3 0-0.6 0.1-0.9 0.1s-0.4 0.1-0.5 0.4c-0.1 0.1-0.1 0.2-0.2 0.3 -0.2 0.6-0.5 1.1-0.9 1.7 -0.6 0.9-1.4 1.5-2.5 1.8 -1.1 0.4-2.2 0.6-3.4 0.6h-0.2 -0.2c-0.7 0-1.3 0.1-2 0.2 -0.3 0-0.6 0.1-0.9 0.1l-2.4 0.4 0 0c-1 0.1-2 0.2-3 0.4l0 0C-36.3 29.4-36.3 29.4-36.4 29.4zM-19.2 22.2L-19.2 22.2c-0.5 0-0.8 0.4-0.9 0.8h0.1 0.1 0.1c0.2 0 0.5-0.1 0.7-0.1 0.6-0.1 1.2-0.1 1.8-0.3 1.2-0.2 2.3-0.8 3.1-1.7 0.3-0.2 0.4-0.6 0.5-1 -0.1-0.3-0.3-0.6-0.6-0.8 -0.4-0.3-0.9-0.4-1.4-0.4 -0.7 0-1.3 0.2-1.8 0.6 -0.1 0.1-0.1 0.2-0.2 0.3 0 0.1-0.1 0.1-0.1 0.2h0.2c0.1 0 0.1 0 0.1 0l0 0 2.3-0.5c0.1 0 0.1 0 0.2 0 0.2 0 0.3 0.1 0.4 0.2 0.2 0.3 0.2 0.6 0.1 0.9 -0.1 0.1-0.2 0.2-0.3 0.3 -0.1 0-0.2-0.1-0.3-0.2 -0.2-0.2-0.4-0.4-0.7-0.4l0 0c-0.6 0.1-1.2 0.3-1.7 0.7 0 0-0.1 0.2 0 0.2 0 0 0.1 0.1 0.2 0.1l0 0c0.1 0 0.1 0 0.2 0s0.1 0 0.2 0l0 0c0.1 0 0.2 0 0.2 0.1h0.1v0.1c0 0.1 0 0.2-0.1 0.2 -0.2 0.1-0.3 0.2-0.5 0.3 -0.1 0-0.2 0.1-0.3 0.1l0 0c-0.1 0-0.1 0.1-0.2 0.1 -0.1 0.2-0.3 0.3-0.4 0.3s-0.2 0-0.3-0.1C-18.8 22.2-19 22.2-19.2 22.2L-19.2 22.2z" fill="currentColor"/></g></g></svg>';
      if (this.tags.indexOf('Coming Soon') >= 0 || this.tags.indexOf('coming soon') >= 0) {
        res += '<p class="ProductItem__Tag ComingSoon h4">'+ oak_collection_logo +' Coming Soon</p>';
      } else if (this.tags.indexOf('in-stock') >= 0) {
        if (this.tags.indexOf('OAK COLLECTION') >= 0 || this.tags.indexOf('oak collection') >= 0) {
          res += '<p class="ProductItem__Tag OneOfAKind h4">'+ oak_collection_logo +' One of a Kind</p>';
        } else if (this.tags.indexOf('na') >= 0) {
          res += '<p class="ProductItem__Tag NewArrival h4"><img src="' + shopify_asset_url_prefix + 'logo-mark-mi-golondrina.svg" width="14" height="14" alt="Blue Bird"> New Arrival</p>';
        } else if (this.tags.indexOf('preorder') >= 0) {
          res += '<p class="ProductItem__Tag Preorder h4"><img src="' + shopify_asset_url_prefix + 'icon-lock.svg" width="14" height="14" alt="Blue Bird">  Preorder</p>';
        } else if (this.compare_at_price > this.price) {
          res += '<p class="ProductItem__Tag OnSale h4">On Sale</p>';
        }
      } else {
        res += '<p class="ProductItem__Tag SoldOut h4">Sold Out</p>';
      }
      return res;
    }
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
